import Model from "../Model";

class Groupview extends Model{

    buildUrl ({ param }) {
        return ['groupview', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Groupview;